

export const EmptyDataHook = (defaultData)=>{
   return Object.keys(defaultData).reduce((acc, key) => {
        acc[key] = "";
        return acc;
    }, {});
    
}